import { useState, type RefObject } from "react";
import { StyledQuestionReadyContent } from "./index.styled";
import PageTitleSubtitle from "../../shared/PageTitleSubtitle";
import QuestionPreviewBox from "../../shared/QuestionPreviewBox";

interface QuestionReadyContentProps {
  questionContent?: string;
  previewRef?: RefObject<HTMLDivElement | null>;
}

const QuestionReadyContent = ({
  questionContent,
  previewRef,
}: QuestionReadyContentProps) => {
  const [noteText, setNoteText] = useState("מחכה לתגובה שלך זה אנונימי :)");

  return (
    <StyledQuestionReadyContent>
      <PageTitleSubtitle
        title="התיבה שלך מוכנה!"
        subtitle="כל הקישורים והפרטים מחכים לך כאן למטה"
      />

      {questionContent ? (
        <div ref={previewRef} className="question-detail-content">
          <QuestionPreviewBox title={questionContent}>
            <input
              className="note-input"
              value={noteText}
              onChange={(e) => setNoteText(e.target.value)}
              placeholder="כתבו הערה לשאלה..."
              dir="rtl"
            />
          </QuestionPreviewBox>
        </div>
      ) : (
        <div className="question-detail-content">
          <div className="not-found-card">
            <p className="not-found-title">השאלה לא נמצאה</p>
            <p className="not-found-subtitle">
              ייתכן שהיא נמחקה או שהקישור אינו תקין
            </p>
          </div>
        </div>
      )}
    </StyledQuestionReadyContent>
  );
};

export default QuestionReadyContent;
